import React from 'react';

import { useObserver } from 'mobx-react-lite';
import map from 'lodash/map';
import get from 'lodash/get';
import { Button } from '@bringg/react-components';
import { useTranslation } from 'react-i18next';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { useWebhooksApiStore, Webhook } from '@bringg-frontend/webhooks-api-internal-stores';

import WebhooksEditUrl from '../webhooks-edit-url/webhooks-edit-url';

interface Props {
	webhook: Webhook;
}

const WebhooksEditUrls: React.FC<Props> = ({ webhook }) => {
	const { t } = useTranslation();
	const { webhooksAppStore } = useWebhooksApiStore();

	return useObserver(() => {
		const testable = get(webhooksAppStore.applicationConfig, `${webhook.key}.testable`, false) as boolean;

		return (
			<>
				<div className="urls">
					{map(webhook.urls, ([uuid, url]) => (
						<WebhooksEditUrl webhook={webhook} key={uuid} uuid={uuid} url={url} testable={testable} />
					))}
				</div>
				<div className="add-url">
					<Button type="primary" shape="circle" onClick={() => webhook.addUrl()}>
						<BringgIcon iconName={BringgFontIcons.Plus} style={{ fontSize: '24px' }} />
					</Button>
				</div>
				<div className="add-url-text">
					<span>{t('WEBHOOK_APP.MODAL.ADD_URL_BUTTON', { defaultValue: 'Add URL' })}</span>
				</div>
			</>
		);
	});
};

export default WebhooksEditUrls;
